import { useLingui } from "@lingui/react";
import { Trans } from "@lingui/react/macro";
import type { ReactNode } from "react";

type LegalDocumentProps = {
  title: ReactNode;
  // Дата редакции (ISO, без времени).
  revision: string;
  children: ReactNode;
};

// Правовой документ по макетам design/prototype/Privacy.dc.html и Terms.dc.html: заголовок,
// дата редакции и разделы с нумерованными пунктами.
export const LegalDocument = ({ title, revision, children }: LegalDocumentProps) => {
  const { i18n } = useLingui();
  // Дата без времени разбирается как полночь UTC — в UTC её и показываем, без сдвига на день.
  const date = new Intl.DateTimeFormat(i18n.locale, {
    dateStyle: "long",
    // eslint-disable-next-line lingui/no-unlocalized-strings -- часовой пояс, а не текст
    timeZone: "UTC",
  }).format(new Date(revision));
  return (
    <article className="flex flex-col gap-7 text-[15px] leading-relaxed text-foreground-soft">
      <header className="flex flex-col gap-2.5">
        <h1 className="font-display text-[40px] leading-[1.1] text-foreground">{title}</h1>
        <p className="text-sm text-subtle">
          <Trans>Last updated: {date}</Trans>
        </p>
      </header>
      {children}
    </article>
  );
};
